import Box from '@mui/material/Box';
import { AutocompleteElement } from 'react-hook-form-mui';
import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import { Chip } from '@mui/material';

interface ProductOption {
  label: string;
  id: number;
  image?: string;
}

interface ProductSelectProps {
  options: ProductOption[] | undefined;
  name: string;
  type: "product" | "collection";
  label?: string;
}

const ProductSelect = React.memo(({
  options,
  name,
  type,
  label = (type === "product" ? "Choose products" : "Choose collections")
}: ProductSelectProps) => {
  return (
    <AutocompleteElement
      multiple
      name={name}
      options={options || []}
      autocompleteProps={{
        disableCloseOnSelect: true,
        size: "small",
        getOptionLabel: (option: ProductOption) => option.label,
        renderOption: (props, option: ProductOption, { selected }) => {
          const { key, ...optionProps } = props;
          return (
            <Box
              key={key}
              component="li"
              sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
              {...optionProps}
            >
              <Checkbox checked={selected} />
              {option.image && <img
                loading="lazy"
                width="20"
                src={option.image}
                alt=""
              />}
              {option.label}
            </Box>
          );
        },
        renderTags: (tagValue, getTagProps) =>
          tagValue.map((option: ProductOption, index) => (
            <Chip
              {...getTagProps({ index })}
              key={option.id}
              label={option.label}
              avatar={
                option.image ? <img
                  src={option.image}
                  alt=""
                  style={{ width: '24px', height: '24px' }}
                /> : <></>
              }
            />
          ))
      }}
      textFieldProps={{
        // @ts-expect-error - MUI typing issue with react-hook-form-mui
        label,
        InputProps: {
          autoComplete: 'new-password',
        }
      }}
    />
  );
});

export default ProductSelect;